import {
  GET_ATTACHMENT,
  GET_ATTACHMENT_FAIL,
  GET_ATTACHMENT_SUCCESS,
  GET_GENERAL,
  GET_GENERAL_FAIL,
  GET_GENERAL_SUCCESS,

  GET_COUNTRY,
  GET_COUNTRY_FAIL,
  GET_COUNTRY_SUCCESS,

  GET_STATE,
  GET_STATE_FAIL,
  GET_STATE_SUCCESS,

  GET_CITY,
  GET_CITY_FAIL,
  GET_CITY_SUCCESS,

  GET_PROFILE_ATTACHMENT,
  GET_PROFILE_ATTACHMENT_FAIL,
  GET_PROFILE_ATTACHMENT_SUCCESS,

  GET_ADVERT_INTEREST_RATE,
  GET_ADVERT_INTEREST_RATE_SUCCESS,
  GET_ADVERT_INTEREST_RATE_FAIL,

  GET_THUMBNAIL_ATTACHMENT_FAIL,
  GET_THUMBNAIL_ATTACHMENT_SUCCESS,
  RESET_THUMBNAIL_ATTACHMENT_STATE,
  RESET_ATTACHMENT_STATE,
  RESET_GENERAL_STATE,
  GET_THUMBNAIL_ATTACHMENT,
  GET_VOUCHER_LIST,
  GET_VOUCHER_LIST_SUCCESS,
  GET_VOUCHER_LIST_FAIL,
  SEND_EMAIL_FAIL,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL,
  RESET_EMAIL_STATE,
  SET_CURRENT_USER,
  GET_REGION,
  GET_REGION_SUCCESS,
  GET_REGION_FAIL,
} from "./actionTypes";

export const getGeneral = () => ({
  type: GET_GENERAL,
});

export const getGeneralSuccess = general => ({
  type: GET_GENERAL_SUCCESS,
  payload: general,
});

export const getGeneralFail = error => ({
  type: GET_GENERAL_FAIL,
  payload: error,
});

export const setCurrentUser = payload => ({
  type: SET_CURRENT_USER,
  payload: payload
});

export const getCountry = () => ({
  type: GET_COUNTRY,
});

export const getCountrySuccess = general => ({
  type: GET_COUNTRY_SUCCESS,
  payload: general,
});

export const getCountryFail = error => ({
  type: GET_COUNTRY_FAIL,
  payload: error,
});

export const getState = (payload) => ({
  type: GET_STATE,
  payload,
});

export const getStateSuccess = general => ({
  type: GET_STATE_SUCCESS,
  payload: general,
});

export const getStateFail = error => ({
  type: GET_STATE_FAIL,
  payload: error,
});

export const getCity = (payload) => ({
  type: GET_CITY,
  payload,
});

export const getCitySuccess = general => ({
  type: GET_CITY_SUCCESS,
  payload: general,
});

export const getCityFail = error => ({
  type: GET_CITY_FAIL,
  payload: error,
});

export const getRegion = (payload) => ({
  type: GET_REGION,
  payload,
});

export const getRegionSuccess = general => ({
  type: GET_REGION_SUCCESS,
  payload: general,
});

export const getRegionFail = error => ({
  type: GET_REGION_FAIL,
  payload: error,
});

export const getAttachment = payload => ({
  type: GET_ATTACHMENT,
  payload: payload
});

export const getAttachmentSuccess = attachment => ({
  type: GET_ATTACHMENT_SUCCESS,
  payload: attachment,
});

export const getAttachmentFail = error => ({
  type: GET_ATTACHMENT_FAIL,
  payload: error,
});

export const getProfileAttachment = payload => ({
  type: GET_PROFILE_ATTACHMENT,
  payload: payload
});

export const getProfileAttachmentSuccess = attachment => ({
  type: GET_PROFILE_ATTACHMENT_SUCCESS,
  payload: attachment,
});

export const getProfileAttachmentFail = error => ({
  type: GET_PROFILE_ATTACHMENT_FAIL,
  payload: error,
});

export const getThumbnailAttachment = payload => ({
  type: GET_THUMBNAIL_ATTACHMENT,
  payload: payload
});

export const getThumbnailAttachmentSuccess = attachment => ({
  type: GET_THUMBNAIL_ATTACHMENT_SUCCESS,
  payload: attachment,
});

export const getThumbnailAttachmentFail = error => ({
  type: GET_THUMBNAIL_ATTACHMENT_FAIL,
  payload: error,
});

export const getVoucherList = payload => ({
  type: GET_VOUCHER_LIST,
  payload: payload
});

export const getVoucherListSuccess = payload => ({
  type: GET_VOUCHER_LIST_SUCCESS,
  payload: payload,
});

export const getVoucherListFail = error => ({
  type: GET_VOUCHER_LIST_FAIL,
  payload: error,
});

export const sendEmail = payload => ({
  type: SEND_EMAIL,
  payload: payload
});

export const sendEmailSuccess = payload => ({
  type: SEND_EMAIL_SUCCESS,
  payload: payload,
});

export const sendEmailFail = error => ({
  type: SEND_EMAIL_FAIL,
  payload: error,
});

export const getAdvertInterestRate = (data) => ({
    type: GET_ADVERT_INTEREST_RATE,
    payload: data,
});

export const getAdvertInterestRateSuccess = data => ({
    type: GET_ADVERT_INTEREST_RATE_SUCCESS,
    payload: data,
});

export const getAdvertInterestRateFail = error => ({
    type: GET_ADVERT_INTEREST_RATE_FAIL,
    payload: error,
});

//reset
export const resetGeneralState = () => {
  return {
    type: RESET_GENERAL_STATE,
  }
}

export const resetAttachmentState = () => {
  return {
    type: RESET_ATTACHMENT_STATE,
  }
}

export const resetThumbnailAttachmentState = () => {
  return {
    type: RESET_THUMBNAIL_ATTACHMENT_STATE,
  }
}

export const resetEmailState = () => {
  return {
    type: RESET_EMAIL_STATE,
  }
}

